import { createContext, useContext, useEffect, useState } from "react";
import API from "./api";
import { SITE } from "@/constants/site";

const SiteContext = createContext(SITE);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(SITE);

  useEffect(() => {
    API.get("/settings/site")
      .then(({ data }) => {
        if (data && Object.keys(data).length) setSite((s) => ({ ...s, ...data }));
      })
      .catch(() => {});
  }, []);

  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
